import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface DeleteDataExtractionReportParams {
	data_extraction_id: string;
	organization_id: string;
	company_id: string;
	reports: {
		custom_report_id?: string | null;
		bera_report_id?: string | null;
		sera_report_id?: string | null;
		report_type?: string;
	}[];
}

const Service = DataExtractionService.getInstance();

export const useDeleteDataExtractionReport = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: DeleteDataExtractionReportParams) => Service.deleteDataExtractionReport(params),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_CUSTOM_REPORT_BY_TYPE_LIST] });
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_DATA_EXTRACTION_SELECTED_REPORTS_COUNT] });
			message.success(I18n.get('The report has been successfully removed from the data extraction'));
		},
		onError: () => {
			message.error(I18n.get('Failed to remove the report from the data extraction'));
		}
	});
};
